import { tryOnScopeDispose } from '@vueuse/core';

type StopFn = () => void;
class ProcessManager {
  private processes = new Map<string, StopFn>();
  register(id: string, stop: StopFn) {
    this.processes.set(id, stop);
    tryOnScopeDispose(() => {
      this.remove(id);
    });
  }
  remove(id: string) {
    const stop = this.processes.get(id);
    if (stop) {
      stop();
      this.processes.delete(id);
    }
  }
  clear() {
    this.processes.forEach(stop => stop());
    this.processes.clear();
  }
}
export const processManager = new ProcessManager();
